import {booleanAttribute, Component, input} from '@angular/core';
import {OuraSleepIntf, SleepTypesDict}      from '@djsharkk/logr-types';
import {TableRowBase}                       from '../table-row-base';
import {TableRow}                           from '../table-wrapper/table-wrapper.component';

@Component({
			   selector   : 'app-table-row-oura-sleep',
			   imports    : [],
			   templateUrl: './table-row-oura-sleep.component.html',
			   styleUrl   : './table-row-oura-sleep.component.css'
		   })
export class TableRowOuraSleepComponent extends TableRowBase<OuraSleepIntf> {
	row = input.required<TableRow>();
	showDate = input(false, {transform: booleanAttribute});
	detailed = input(false, {transform: booleanAttribute});
	protected readonly SleepTypesDict = SleepTypesDict;
}
